import {Component , ViewChild } from '@angular/core';
import {NavController, ToastController ,AlertController ,Content ,MenuController , Events, ModalController,FabContainer} from 'ionic-angular';
import {OrderConfirmPage} from "../order-confirm/order-confirm";
import {SearchPage} from "../search/search";
import {CustomerWishListPage} from "../customer-wish-list/customer-wish-list";
import {CartManager} from "../../providers/cart-manager";
import {CART, Customer, loginUserInfo, selectedLocationTemorary} from "../../providers/data";
import { BarcodeScanner, Printer} from 'ionic-native';
import { Http, Headers, RequestOptions} from '@angular/http';
import {Api} from "../../providers/api";
import {ApiOffline} from "../../providers/api-offline";
import {IMAGES_BASE_URL,ApplicationVariables} from '../../providers/config';
import {CustomerCarts} from '../../providers/user-cart-provider/user-carts';
import {ItemsPage} from '../items/items';
import {LoginPage} from '../login/login';
import {MyOrderPage} from '../my-order/my-order';
import {Constants} from '../../providers/config';
import 'rxjs/add/operator/map';
import {GVLogger} from '../../services/gv-logger';
import { MsgManager } from '../../providers/msg-manager';
import { ItemPage } from '../item-details/item-details';
import { Storage } from '@ionic/storage';
import { BookmarksPage } from '../bookmarks/bookmarks';

@Component({
  selector: 'page-cart',
  templateUrl: 'cart.html'
})
export class CartPage {

  isWebstore = 0;
  // isOfflineMode:any = false;

  tempDropshipLocation:any  = false;

  public constants = Constants;
  public multipleCarts = false;
  public cart: any;
  public TotalPrice:number = 0;
  public TotalPriceBeforeTax:number = 0;
  baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;
  public barCodeFocus = "Keep focus here to scan QR/Scan Code.";
  @ViewChild('barcodeFocus') barCodeFocusInput ;
  @ViewChild(Content) content: Content;
  taxPercent = 0; // changed from  0.13
  TAX = 0;
  public locationSelected = 0;
  haveTitle:boolean = false;
  cartTitleTemp:string = "";
  orderStatus:number;
  cacheImages:any;
  adpCustomerInfo:any ={};
  customerId: any;
  selectedCurrency = ""


  constructor(
    public nav: NavController,
    private cartManager: CartManager,
    public http: Http,
    public api:Api,
    public toastCtrl:ToastController,
    public menuController:MenuController,
    public alertCtrl: AlertController,
    public menu:MenuController,
    public customerCarts:CustomerCarts,
    public events:Events,
    private gVLogger:GVLogger,
    private fab:FabContainer,
    private msgManager:MsgManager,
    private modalController:ModalController,
    private apiOffline:ApiOffline,
    private storage:Storage) {

    this.cart = CART;
    this.customerId = this.cart.customer.id;

    for(let item of this.cart.items){
      this.gVLogger.log("DDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDd" + JSON.stringify(item));
      item.discountPrice = item.originalDiscountPrice;
      item.productDiscountDTO = null;
    }

    this.api.get("customers/"+ this.customerId).map(res => res.json()).subscribe(result => {
      this.cart.customer.locationsDTOs = result.data.locationsDTOs;
      this.cart.customer.name = result.data.name;

    });
    this.locationSelected = selectedLocationTemorary.location;
    this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();

    this.storage.get("cacheImages").then((cache)=>{
      this.cacheImages = cache;
    });

    if(Constants.isWebstore){
      this.isWebstore = 1;
    }

    setTimeout(() => {

      if(this.cart.orderId <= 0){


        for(let loc of this.cart.customer.locationsDTOs){

          if(this.locationSelected === 0){
            if(loc.isShipToAddress === 1){

              if(loc.dropshipLocation === undefined || loc.dropshipLocation === '' ){

                this.gVLogger.log("dropshipLocation not found --- ");
                this.locationSelected = loc.id;
              }
              else{
                this.gVLogger.log("dropshipLocation found --- ");
                this.locationSelected = loc.id;
                this.tempDropshipLocation = JSON.parse(this.cart.customer.locationsDTOs[0].dropshipLocation);
                this.tempDropshipLocation = [this.tempDropshipLocation.addressLine1,  this.tempDropshipLocation.city, this.tempDropshipLocation.state, this.tempDropshipLocation.country].join();
              }

            }
          }
        }
      }else{
        this.gVLogger.log("elsee executeddddddd" + this.cart.orderId);
        this.locationSelected = 0;
      }

    }, 400);

    this.cartManager.removeJunkFromCart();

    this.orderStatus = this.cartManager.getOrderStatus();
    this.cartTitleTemp = this.cartManager.getOrderTitle();

    this.events.publish("titleChange");

    if(this.cartTitleTemp != ""){
      this.haveTitle = true;
    }

    this.events.subscribe("titleChange" ,()=>{
      this.cartTitleTemp = this.cartManager.getOrderTitle();
      // this.gVLogger.log("title changed : " ,this.cartTitleTemp);
      if(this.cartTitleTemp == ""){
        this.haveTitle = false;
      }else{
        this.haveTitle = true;
      }
    });

    this.refreshTotalPrice();
    this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
    this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;

    if(!Constants.isWebstore && !ApplicationVariables.isOffline){
      this.getCustomerCarts(0);
    }
    this.events.subscribe("cartUpdated",()=>{
      this.refreshTotalPrice();
    });


    if(loginUserInfo.multiCurrencyFlag === 1 && Customer.paymentCurrency !== undefined && Customer.paymentCurrency !== "")
      this.selectedCurrency = Customer.paymentCurrency;
    else
      this.selectedCurrency = this.adpCustomerInfo.selectedCurrencySymbol

  }

  ionViewDidLoad(){

    this.cartManager.removeJunkFromCart();
    setTimeout(() => {
      // Keyboard.show() // for android
      if(!Constants.isWebstore){
        this.barCodeFocusInput.setFocus();//UD
      }
    },800); //a least 150ms.

  }


  updateProductInCart(product){
    if(String(product.quantity) !=""){
      if(String(product.quantity).match(/^\d+$/)){
        this.cartManager.updateCartNew(product);
      }else{
        product.quantity = Number(product.minOrder);
        this.cartManager.updateCartNew(product);
      }
    }else{
      product.quantity = Number(product.minOrder);
      this.cartManager.updateCartNew(product);
    }
    this.refreshTotalPrice();

  }

  // place order
  buy() {
    if(this.cart.items.length > 0){
      if(this.locationSelected == 0 || this.locationSelected == undefined){
        this.msgManager.toastMsg("Please select a shipto location first.");
      }else{
        if(!Constants.isWebstore && this.cartManager.getOrderTitle() == ""){
          let prompt = this.alertCtrl.create({
            title: 'Please enter title for the active cart',
            inputs: [
              {
                name: 'title',
                placeholder: 'Title'
              },
            ],
            buttons: [
              {
                text: 'Cancel',
                handler: data => {
                  //  this.gVLogger.log('Cancel clicked');
                }
              },
              {
                text: 'Confirm',
                handler: data => {



                  this.cartManager.setOrderTitle(data.title);
                  this.cart.items[0].customerId = Customer.id

                  this.api.post("discount/getProductDiscountedPrice", JSON.stringify(this.cart.items))
                    .map(res => res.json())
                    .subscribe(resp => {
                        if(resp.status == "401"){ // check for session out
                          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                          this.nav.setRoot(LoginPage);
                        }
                        if (resp.status == "200") {

                          for(let discountDto of resp.data){
                            this.cart.items.find(x => x.id === discountDto.productId).discountPrice = discountDto.discountedPrice;
                            this.cart.items.find(x => x.id === discountDto.productId).productDiscountDTO = discountDto;
                          }

                          let orderProducts = []
                          for(let item of CART.items){
                            var orderDetailDTOs: any = {

                              "productsDTO":item,
                              "quantity": item.quantity,
                            };

                            orderProducts.push(orderDetailDTOs);
                          }

                          let body = {
                            "id":CART.orderId,
                            "salesManId":CART.user.id,
                            "orderMessage":CART.orderMessage,
                            "expectedShipmentDate": CART.expectedShipmentDate,
                            "totalTexAmount":"10",
                            "orderStatus":status,
                            "customerDTO":CART.customer,
                            "orderDetailDTOs": orderProducts,
                          }

                          for(let loc of body.customerDTO.locationsDTOs){
                            if(loc.id === this.locationSelected){
                              delete loc.dropshipLocation;
                              body.customerDTO.locationsDTOs[0].dropshipLocation = JSON.stringify(loc);
                            }
                          }


                          this.api.post("tax/getOrderTax",JSON.stringify(body)).map(res => res.json()).subscribe(data => {
                            if(data.status == "401"){ // check for session out
                              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                              this.nav.setRoot(LoginPage);
                            }
                            if(data.status == "200"){

                              console.log("CART.totalTaxCART.totalTax " + data.data.tax)
                              CART.totalTax = data.data.tax;
                              this.nav.push(OrderConfirmPage,{TotalPrice: this.TotalPriceBeforeTax, locationSelected: this.locationSelected});
                            }

                          })

                        } else {
                          this.nav.push(OrderConfirmPage,{TotalPrice: this.TotalPriceBeforeTax, locationSelected: this.locationSelected});


                          let toast = this.toastCtrl.create({
                            message: resp.message,
                            duration: 3000
                          });
                          toast.present();

                        }

                      }
                      , error => {

                      });

                  // this.nav.push(OrderConfirmPage,{TotalPrice: this.TotalPriceBeforeTax, locationSelected: this.locationSelected});

                  this.events.publish("titleChange");
                }
              }
            ]
          });
          prompt.present();
        }else{
          this.cart.items[0].customerId = Customer.id

          this.api.post("discount/getProductDiscountedPrice", JSON.stringify(this.cart.items))
            .map(res => res.json())
            .subscribe(resp => {
                if(resp.status == "401"){ // check for session out
                  this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                  this.nav.setRoot(LoginPage);
                }
                if (resp.status == "200") {

                  for(let discountDto of resp.data){
                    this.cart.items.find(x => x.id === discountDto.productId).discountPrice = discountDto.discountedPrice;
                    this.cart.items.find(x => x.id === discountDto.productId).productDiscountDTO = discountDto;
                  }

                  // this.nav.push(OrderConfirmPage,{TotalPrice: this.TotalPriceBeforeTax, locationSelected: this.locationSelected});

                  let orderProducts = []
                  for(let item of CART.items){
                    var orderDetailDTOs: any = {

                      "productsDTO":item,
                      "quantity": item.quantity,
                    };

                    orderProducts.push(orderDetailDTOs);
                  }

                  let body = {
                    "id":CART.orderId,
                    "salesManId":CART.user.id,
                    "orderMessage":CART.orderMessage,
                    "expectedShipmentDate": CART.expectedShipmentDate,
                    "totalTexAmount":"10",
                    "orderStatus":status,
                    "customerDTO":CART.customer,
                    "orderDetailDTOs": orderProducts,
                  }

                  for(let loc of body.customerDTO.locationsDTOs){
                    if(loc.id === this.locationSelected){
                      delete loc.dropshipLocation;
                      body.customerDTO.locationsDTOs[0].dropshipLocation = JSON.stringify(loc);
                    }
                  }

                  this.api.post("tax/getOrderTax",JSON.stringify(body)).map(res => res.json()).subscribe(data => {
                    if(data.status == "401"){ // check for session out
                      this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                      this.nav.setRoot(LoginPage);
                    }
                    if(data.status == "200"){

                      console.log("CART.totalTaxCART.totalTax " + data.data.tax)
                      CART.totalTax = data.data.tax;
                      this.nav.push(OrderConfirmPage,{TotalPrice: this.TotalPriceBeforeTax, locationSelected: this.locationSelected});
                    }

                  })
                } else {
                  this.nav.push(OrderConfirmPage,{TotalPrice: this.TotalPriceBeforeTax, locationSelected: this.locationSelected});


                  let toast = this.toastCtrl.create({
                    message: resp.message,
                    duration: 3000
                  });
                  toast.present();

                }

              }
              , error => {

              });


          // this.nav.push(OrderConfirmPage,{TotalPrice: this.TotalPriceBeforeTax, locationSelected: this.locationSelected});
        }
      }
    }else{
      this.msgManager.toastMsg("Please add product(s) to cart first.");
    }

  }

  addFromBarCode(event){
    event.target.value = event.target.value.trim();
    setTimeout(()=>{
      if(event.target.value !== ""){
        let body = {barCode: event.target.value, isWebstore: this.isWebstore, refNo : "-1"};
        this.api.post("products/getProductByBarcode", body)
          // this.api.get("products/getProductByBarcode/?barcode="+event.target.value+"&isWebStore="+this.isWebstore+ "&refNo=" + "-1")
          .map(res => res.json())
          .subscribe(data => {
            if(data.status == "401"){ // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

              this.nav.setRoot(LoginPage);
            }else if(data.status == 200){
              if(data.data.id != 0){

                if(data.data.productType === 0){
                  this.addProductToCart(data.data);
                  setTimeout(()=>{
                    event.target.value = "";
                    event.target.focus();
                  },500)
                }else if(data.data.productType === 1 && data.data.qtyONHAND > 0){
                  this.addProductToCart(data.data);
                  setTimeout(()=>{
                    event.target.value = "";
                    event.target.focus();
                  },500)
                }else{
                  this.msgManager.toastMsg("This product is not available in inventory!");
                  setTimeout(()=>{
                    event.target.value = "";
                    event.target.focus();
                  },500)
                }
                this.scrollBottom();
                event.target.value = "";
                event.target.focus();

              }

            }
          });
        setTimeout(()=>{
          event.target.value = "";
          event.target.focus();
        },500);
      }
    },500);

    setTimeout(()=>{
      event.target.value = "";
      event.target.focus();
    },500);
  }

  holdCart(){

    if(Number(this.cartManager.getProductsCount()) < 1){
      this.msgManager.toastMsg("Can't hold empty cart.");
      return null;
    }

    if(!Constants.isWebstore && this.cartManager.getOrderTitle() == ""){
      let prompt = this.alertCtrl.create({
        title: 'Please enter title for the active cart',
        inputs: [
          {
            name: 'title',
            placeholder: 'Title'
          },
        ],
        buttons: [
          {
            text: 'Cancel',
            handler: data => {
            }
          },
          {
            text: 'Hold',
            handler: data => {
              this.cartManager.setOrderTitle(data.title);
              var body:any = this.cartManager.genrateOrder(2, loginUserInfo.customerShippingCost); // status 2 for HOLD
              let headers = new Headers({
                'Content-Type': 'application/json'
              });
              let options = new RequestOptions({
                headers: headers
              });
              this.api.post("order/place",JSON.stringify(body), options)
                .map(res => res.json())
                .subscribe(resp => {
                    if(resp.status="200"){

                      this.cartManager.clearCart();
                      this.cartManager.setOrderTitle("");
                      this.cartManager.setShipDate("");
                      this.cartManager.setOrderMessage("");
                      this.cartManager.setOrderId(0);
                      this.nav.setRoot(ItemsPage);
                    }else if(resp.status == "401"){ // check for session out
                      this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                      this.nav.setRoot(LoginPage);
                    }

                  }
                  , error =>{
                    //    this.gVLogger.log("update call failed");
                  });

            }
          }
        ]
      });
      prompt.present();
    }else{
      var body:any = this.cartManager.genrateOrder(2, loginUserInfo.customerShippingCost); // status 2 for HOLD

      let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });
      this.api.post("order/place",JSON.stringify(body), options)
        .map(res => res.json())
        .subscribe(resp => {
            if(resp.status="200"){

              this.cartManager.clearCart();
              this.cartManager.setOrderTitle("");
              this.cartManager.setShipDate("");
              this.cartManager.setOrderMessage("");
              this.cartManager.setOrderId(0);
              //   this.gVLogger.log("updated successfully");
              this.nav.setRoot(ItemsPage);
            }else if(resp.status == 401){ // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

              this.nav.setRoot(LoginPage);
            }

          }
          , error =>{
            // this.gVLogger.log("update call failed");
          });
    }

  }


  // go to search page
  goToSearch() {
    this.menuController.close("testRightMenu");
    this.nav.push(SearchPage);
  }


  refreshTotalPrice(){
    this.cart = CART;
    let temp:number = 0;
    for(let item of this.cart.items){
      if(this.discountCheck(item.discountPrice)){
        temp =  temp + (Number(item.discountPrice) * Number(item.quantity));
      }else{

        temp =  temp + (Number(item.price) * Number(item.quantity));
      }
    }
    this.TotalPriceBeforeTax =  Number(temp.toFixed(2));
    this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
    this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;
  }

  addProductToCart(item){
    this.cartManager.addProductToCart(item);
    this.refreshTotalPrice();
    return true;
  }

  removeProductFromCart(product){

    this.cartManager.removeOneNew(product);
    if(product.quantity == 0){
      this.cartManager.deleteProductFromCart(product);
    }
    this.refreshTotalPrice();
  }


  cameraBarcodeScanner(){

    this.gVLogger.log("Camera barcode Scanner");
    BarcodeScanner.scan().then((barcodeData) => {
      this.msgManager.startLoading();

      if (!barcodeData.cancelled) {

        this.api.get("/products/barcode/"+barcodeData.text+"?isWebStore="+this.isWebstore)
          .map(res => res.json())
          .subscribe(data => {

            this.msgManager.stopLoading();
            if(data.status == "401"){ // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

              this.nav.setRoot(LoginPage);
            }else if(data.status == 200){
              if(data.data.id != 0){
                this.cartManager.addProductToCart(data.data);

              }
              //alert("Product added successfully.");
            }
          }, (err)=>{
            this.msgManager.stopLoading();
          });

      }else{
        this.msgManager.stopLoading();
      }


    }, (err) => {
      this.msgManager.stopLoading();
      //alert("ERROR: "+JSON.stringify(err));
    });

  }


  deleteProductFromCart(product){

    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: "Are you sure you want to delete '"+product.name+"' from the cart?",
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            //  this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {
            // this.gVLogger.log('Agree clicked');
            this.cartManager.deleteProductFromCart(product);
            this.refreshTotalPrice();
          }
        }
      ]
    });
    confirm.present();




  }
  clearCart(){
    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: 'You want to clear all the products from cart',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {

          }
        },
        {
          text: 'Agree',
          handler: () => {
            // this.gVLogger.log('Agree clicked');
            this.cartManager.clearCartProducts();
            this.refreshTotalPrice();
          }
        }
      ]
    });
    confirm.present();
  }

  onFocusBarcode(event){
    event.target.value = "";
    this.barCodeFocus = "Scanner ACTIVE";
  }
  onBlurBarcode(event){
    event.target.value = "";
    this.barCodeFocus = "Keep focus here to scan QR/Scan Code.";
  }

  activateBarcodeField(){
//this.gVLogger.log("activateBarcodeField Loaded");
    setTimeout(() => {
      // Keyboard.show() // for android
      this.barCodeFocusInput.setFocus();
    },100); //a least 150ms.
  }

  locationSelectedChange(event){
    // alert(event);
    CART.tempShipTo = undefined
    this.locationSelected = event;
    selectedLocationTemorary.location = event;
  }

  imageNotFound(e,item){
    item.productImagesDTO[0].extension = "png";
    item.productImagesDTO[0].name = "dummy";
  }

  discardCart(){    // TODO: Check if order contains ID delete on Server else Delete local
    selectedLocationTemorary.location = 0;
    this.menu.close('testRightMenu');
    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: 'You want to discard this Cart',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            //  this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {
            // this.gVLogger.log('Agree clicked');

            if(this.cartManager.getOrderId() == 0){
              this.gVLogger.log("Local Order");
              this.cartManager.clearCartProducts();
              this.cartManager.setOrderTitle("");
              this.cartManager.setOrderId(0);
              this.refreshTotalPrice();
              this.nav.setRoot(ItemsPage);
              this.cart.tempShipTo = undefined;
            }else{
              // TODO: send call to server

              let body = "?orderId="+this.cartManager.getOrderId()+"&customerId="+this.cartManager.getSalesManId();

              this.api.post("order/discard"+body,null).map(res => res.json()).subscribe(result=>{
                if(result.status == 200){
                  this.cartManager.clearCartProducts();
                  this.cartManager.setOrderTitle("");
                  this.cartManager.setOrderId(0);
                  this.refreshTotalPrice();
                  this.nav.setRoot(ItemsPage);
                }else if(result.status == "401"){ // check for session out
                  this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                  this.nav.setRoot(LoginPage);
                }
              });

            }

          }
        }
      ]
    });
    confirm.present();
  }



  scrollBottom(){
    setTimeout(()=>{
      this.content.scrollToBottom(200);
    },400)
  }
  scrollToItem(yOffset){
    this.content.scrollTo(0, yOffset, 200);
  }

  toggleRignt(){
    // this.menu.enable(true, 'testRightMenu');
    // this.menu.enable(false, 'sideMenu');
    this.menu.toggle('testRightMenu');
  }

  getCustomerCarts(startPoint){

    let body = "?customerId="+this.cartManager.getCustomerID()+"&startPoint="+startPoint;
    this.gVLogger.log("bodddddyyy-----"+ body);
    this.api.post("order/loadByCustomer"+body,null)
      .map(res => res.json())
      .subscribe(data => {
        if(data.status == 200){
          this.gVLogger.log("----------order load by customer------"+ data);
          this.customerCarts.setCustomerCarts(data.data);
          let cartsOnhold:number = 0;
          for(let cart of data.data){
            if(cart.orderStatus == 2) {
              cartsOnhold += 1;
            }
          }
          //  this.gVLogger.log(data);
          if(cartsOnhold > 0){
            this.multipleCarts = true;
          }
        }else if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }else {
          this.msgManager.toastMsg(data.message);
        }
      });
  }



  newCart(){
    selectedLocationTemorary.location = 0;

    if(Number(this.cartManager.getProductsCount()) < 1){
      this.msgManager.toastMsg("Cart is already empty");
      return null;
    }
    if(this.cartManager.getOrderStatus() == 4){

      this.cartManager.clearCart();
      this.cartManager.setOrderTitle("");
      this.cartManager.setOrderMessage("");
      this.cartManager.setOrderStatus(0);
      this.cartManager.setOrderId(0);
      this.refreshTotalPrice();
      this.nav.setRoot(ItemsPage);
    }
    else{

      this.cartManager.clearCart();
      this.cartManager.setOrderTitle("");
      this.cartManager.setOrderMessage("");
      this.cartManager.setOrderId(0);
      this.cartManager.setOrderStatus(0);
      this.refreshTotalPrice();
      this.nav.setRoot(ItemsPage);

    }

  }



  discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }


  getNumber(val: any) {
    if (isNaN(val)) return 0;
    return +val;
  }

  decimalLengthFixed(num,max){
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }


  gotoItemsPage(){
    this.nav.setRoot(ItemsPage);
  }

  gotoOrdersPage(){
    this.nav.setRoot(MyOrderPage);
  }
  logOut(){
    this.nav.setRoot(LoginPage);
  }

  gotoSingleView(product){
    this.api.get("product/" + product.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
      if(data.status === "200"){
        product.description = data.data.description;
      }
    })
    this.nav.push(ItemPage, {item: product});
  }


  makeImageURL(dimensions,item){
    return this.cartManager.makeImageURL(dimensions,item);
  }


  gotoBookmarksPage(){
    this.fab.close();
    this.nav.push(BookmarksPage);
  }

  locationAddress1(addressLine1){
    // this.gVLogger.log("locationAddress1 called" + addressLine1);
    if(addressLine1 === "" || addressLine1 === null || addressLine1 === undefined){
      return false;
    }
    else
    {
      return true;
    }
  }

  locationTypeCheck(type){
    if(type === "BILLTOSHIPTO" || type === "SHIPTO"){
      return true;
    }
    else{
      return false;
    }

  }

  setTempLocationUndefined(){
    // alert("UD")
    CART.tempShipTo = undefined
  }

}



// WEBPACK FOOTER //
// ./src/pages/cart/cart.ts